export const routes = {
  article: {
    path: '/:locationId/*'
  },
  register: {
    path: '/signup'
  },
  signin: {
    path: '/signin'
  },
  signout: {
    path: '/signout'
  },
  internalLogin: {
    path: '/admin/internal-login'
  },
  b2cFreeRegister: {
    path: '/signup/free'
  },
  b2cRegister: {
    path: '/signup/:plan'
  },
  b2cSocialSignUpRedirect: {
    path: '/social-signup/redirect/:plan'
  },
  b2cRegisterSuccess: {
    path: '/b2c/sign-up/success/:username/:planCode'
  },
  b2cFreeRegisterSuccess: {
    path: '/b2c/sign-up/success/free'
  },
  login: {
    path: '/login'
  },
  'verify-email': {
    path: '/verify-email/:username/:code'
  },
  'resend-email': {
    path: '/verify-email'
  },
  'recovery-password': {
    path: '/password-recovery'
  },
  'recovered-password': {
    path: '/password-recovered'
  },
  'reset-password-end': {
    path: '/password-reset-end'
  },
  'reset-password': {
    path: '/password-reset/:username/:code'
  },
  'change-password': {
    path: '/change-password'
  },
  bookmarks: {
    path: '/bookmarks'
  },
  myLearning: {
    path: '/my-learning'
  },
  serp: {
    path: '/search-results'
  },
  profile: {
    path: '/profile'
  },
  retention: {
    path: '/profile/retention'
  },
  playlists: {
    path: '/playlists'
  },
  quizzes: {
    path: '/quizzes'
  },
  playlist: {
    path: '/playlists/:playlistId'
  },
  'playlist-edit': {
    path: '/playlists/:playlistId/edit'
  },
  'playlist-create': {
    path: '/playlists/new'
  },
  'ai-skills-practice': {
    path: '/ai-skills-practice'
  },
  'skill-bites': {
    path: '/skill-bites'
  },
  'skill-bite': {
    path: '/skill-bites/:skillBiteId/'
  },
  'skill-bite-session': {
    path: '/skill-bites/:skillBiteId/:sessionId/'
  },
  msb: {
    path: '/msb'
  },
  accelerate: {
    path: '/accelerate'
  },
  'accelerate-assessment-report': {
    path: '/accelerate/assessment-report'
  },
  'learning-journey': {
    path: '/accelerate/learning-journey'
  },
  'accelerate-skill-bites': {
    path: '/accelerate/skill-bites'
  },
  'accelerate-modals-demo': {
    path: '/accelerate/modals-demo'
  },
  'accelerate-badges-demo': {
    path: '/accelerate/badges-demo'
  },
  'assessment-details': {
    path: '/assessments/:assessmentId/'
  },
  'assessment-report': {
    path: '/assessments/:assessmentId/report'
  },
  'assessment-organization-overview': {
    path: '/assessments/:assessmentId/organization-overview'
  },
  'privacy-policy': {
    path: '/policies/privacy'
  },
  'cookie-policy': {
    path: '/policies/cookie'
  },
  tandc: {
    path: '/policies/tandc'
  },
  'a11y-statement': {
    path: '/policies/a11y'
  },
  'about-our-content': {
    path: '/policies/about-our-content'
  },
  'newest-releases': {
    path: '/newest-releases'
  },
  'most-popular': {
    path: '/most-popular'
  },
  maintenance: {
    path: 'maintenance'
  },
  // 'bonus-material': {
  //   path: '/bonus-material'
  // },
  author: {
    path: '/authors/:slug'
  },
  contentOnlyArticle: {
    path: '/:locationId/*'
  },
  cornerstoneLegacy: {
    path: '/cornerstone/:locationId/*'
  },
  home: {
    path: '/home'
  },
  index: {
    path: '/'
  },
  indexHtml: {
    path: '/index.html'
  },
  error404: {
    path: '/not-found'
  },
  migrationError404: {
    path: '/migration/not-found'
  },
  welcome: {
    path: '/welcome'
  },
  reporting: {
    path: '/reporting'
  },
  '*': {
    path: '*'
  }
}
